module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Lavori-BN.7da4a971.svg";